module.exports = __webpack_public_path__ + "static/img/1.f92f920.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/1.png
// module id = huCO
// module chunks = 4